import { tumourTypes } from '../constants';


export const validateAnalysisValues = (values) => {
    const { tumourType } = values;

    if (!tumourType) {
        console.log('tumourType is missing')
        return false;
    }

    if (tumourType === tumourTypes.NO_PRIMARY_TUMOUR || tumourType === tumourTypes.OTHER) {
        return true;
    }

    if (tumourType === tumourTypes.ADENOCARCINOMA) {
        const { tumourExtent1, tumourExtent2, tumourExtent3 } = values;
        if (!tumourExtent1 || tumourExtent1 === "") {
            console.log('tumourExtent1 is missing')
            return false;
        }
        const tumourExtentExtraValuesIsSet = (tumourExtent2 && tumourExtent2 !== "") || (tumourExtent3 && tumourExtent3 !== "");
        if (!tumourExtentExtraValuesIsSet) {
            console.log("neither tumourExtent2 or tumourExtent 3 has values")
            return false;
        }


        const { primaryGrade, highestRemainingGrade, specifyGradeIndeterminatedReason } = values;

        const histologicalGradeIsSet = (primaryGrade !== undefined && primaryGrade !== null && primaryGrade !== false)
            || (highestRemainingGrade !== undefined && highestRemainingGrade !== null && highestRemainingGrade !== false)
            || (specifyGradeIndeterminatedReason !== undefined && specifyGradeIndeterminatedReason !== null && specifyGradeIndeterminatedReason !== false);

        const { isupGrade } = values;
        const isupGradeIsSet = isupGrade !== undefined && isupGrade !== null && isupGrade !== false;

        const formIsValid = isupGradeIsSet || histologicalGradeIsSet;

        return formIsValid;

    }

    return true; //Will never go here

}